import React, { useRef, useEffect } from "react";

// Twinkling starfield + drifting comets on a canvas.
export default function Starfield({ className = "" }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let raf;
    let stars = [];
    let comets = [];

    function resize() {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      const count = Math.floor((canvas.width * canvas.height) / 6000);
      stars = Array.from({ length: count }, () => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 1.6 + 0.3,
        a: Math.random(),
        s: Math.random() * 0.02 + 0.004,
      }));
    }
    resize();
    window.addEventListener("resize", resize);

    function spawnComet() {
      comets.push({
        x: Math.random() * canvas.width,
        y: -20,
        vx: -(Math.random() * 2 + 1.5),
        vy: Math.random() * 2 + 2,
        life: 0,
        max: 120,
      });
    }

    let frame = 0;
    function draw() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (const st of stars) {
        st.a += st.s;
        const alpha = 0.4 + Math.abs(Math.sin(st.a)) * 0.6;
        ctx.beginPath();
        ctx.arc(st.x, st.y, st.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255,${alpha})`;
        ctx.fill();
      }
      frame++;
      if (frame % 160 === 0 && comets.length < 3) spawnComet();
      comets = comets.filter((c) => c.life < c.max && c.y < canvas.height + 40);
      for (const c of comets) {
        c.x += c.vx;
        c.y += c.vy;
        c.life++;
        const grad = ctx.createLinearGradient(c.x, c.y, c.x + 60, c.y - 60);
        grad.addColorStop(0, "rgba(0,240,255,0.9)");
        grad.addColorStop(1, "rgba(0,240,255,0)");
        ctx.strokeStyle = grad;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(c.x, c.y);
        ctx.lineTo(c.x + 60, c.y - 60);
        ctx.stroke();
      }
      raf = requestAnimationFrame(draw);
    }
    draw();

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className={`absolute inset-0 w-full h-full pointer-events-none ${className}`}
    />
  );
}
